module.exports = __webpack_public_path__ + "static/media/stop-12.10cb259f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-12.svg
// module id = 1379
// module chunks = 0